const D = new Date();

const months = {
  january: 0,
  february: 1,
  march: 2,
  april: 3,
  may: 4,
  june: 5,
  july: 6,
  august: 7,
  september: 8,
  october: 9,
  november: 10,
  december: 11,
};

const isLeapYear = () => D.getFullYear() % 4 !== 0;

const daysInMonth = [
  31, isLeapYear() ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31,
];

const utcDate = date => new Date(
  date.getUTCFullYear(),
  date.getUTCMonth(),
  date.getUTCDate(),
  date.getUTCHours(),
  date.getUTCMinutes(),
  date.getUTCSeconds(),
  date.getUTCMilliseconds(),
);

const suffix = (n) => {
  const j = n % 10;
  const k = n % 100;

  if (j === 1 && k !== 11) {
    return 0;
  }
  if (j === 2 && k !== 12) {
    return 1;
  }
  if (j === 3 && k !== 13) {
    return 2;
  }
  return 3;
};

const DATES = {
  MONTHS: m => months[m],
  DAYSIN: m => daysInMonth[m],
  ISLEAP: isLeapYear(),
  UTC: utcDate,
  SUFFIX: date => suffix(date),
};

export default DATES;



// WEBPACK FOOTER //
// ./src/helpers/date.js